import { useMemo } from 'react'

/**
 * Given an activeTabLanguage, should we show the language warning on the
 * sidebar or automation overlay? This was isLanguageSupported in 1.0.
 */
export function getShowLanguageWarning(
  activeTabLanguage: string | null | undefined,
): boolean | undefined {
  // Still loading
  if (activeTabLanguage === undefined) {
    return undefined
  }
  // Default to not showing the language warning
  if (activeTabLanguage === null) {
    return false
  }
  // If the language is specifically US english, do not show the language
  // warning
  if (activeTabLanguage === 'en' || activeTabLanguage === 'en-US') {
    return false
  }
  // Show the language warning for anything that isn't US english
  return true
}

/**
 * Given an activeTabLanguage, should we show the language warning on the
 * sidebar or automation overlay? This was isLanguageSupported in 1.0.
 */
export function useShowLanguageWarning(
  activeTabLanguage: string | null | undefined,
): boolean | undefined {
  return useMemo(
    () => getShowLanguageWarning(activeTabLanguage),
    [activeTabLanguage],
  )
}
